import styled from 'styled-components';
import { H2 } from '../../../styles/FontStyles';

import fistHubBackground from '../../../assets/images/backoffice/akasha/ahashaFistHubBackground.png';
import fistHubBackgroundMobile from '../../../assets/images/backoffice/akasha/ahashaFistHubBackgroundMobile.png';

import akasha1 from '../../../assets/images/backoffice/akasha/ahasha1.png';
import akasha2 from '../../../assets/images/backoffice/akasha/ahasha2.png';
import akasha3 from '../../../assets/images/backoffice/akasha/ahasha3.png';
import akasha4 from '../../../assets/images/backoffice/akasha/ahasha4.png';
import akasha5 from '../../../assets/images/backoffice/akasha/ahasha5.png';
import akasha6 from '../../../assets/images/backoffice/akasha/ahasha6.png';

import { Box } from '../../../styles/GlobalComponents';

export const AkashaTitle = styled.p`
  background: linear-gradient(
    90deg,
    #2e4963 0%,
    #37b0c0 33%,
    #46a894 71%,
    #46536b 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 24px;
  font-weight: bold;
  margin-top: 20px;
`;

export const AkashaPackageH2 = styled(H2)`
  display: block;
  background: linear-gradient(
    90deg,
    #2e4963 0%,
    #37b0c0 33%,
    #46a894 71%,
    #46536b 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

// export const Tab = styled.div`
//   display: flex;
//   align-items: center;
//   color: #fff;
//   border-radius: 50px;
//   padding: 12px;
//   margin-top: 10px;
//   background: linear-gradient(90deg, #084851 0%, #01899c 100%);
//   width: 75%;

//   @media (max-width: 800px) {
//     width: 100%;
//     // flex-direction: column;
//   }
// `;

export const AkashaGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  /* margin: 0 140px; */
  @media (max-width: 1000px) {
    grid-template-columns: 1fr;
    margin: 0;
  }
`;

export const AdvantagesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  /* margin: 0 140px; */
  @media (max-width: 1000px) {
    grid-template-columns: 1fr;
    margin: 0;
  }
`;

export const GridItem = styled(Box)<{
  selected: boolean;
}>`
  background-color: ${({ theme }) => theme.colors.neutral900};
  border-radius: 30px;
  padding: 10px;
  text-align: center;
  > div {
    padding: 0 20px;
  }
  /* ${({ selected, theme }) =>
    selected &&
    `
      background-color: ${theme.colors.secondaryBlue};
    `} */
  margin-bottom: 0;

  @media (max-width: 1000px) {
    width: 100%;
  }
`;

export const PackagesTitle = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 40px;
  line-height: 140%;
  margin-top: 60px;
  margin-bottom: 20px;
  text-align: center;
  letter-spacing: 0.02em;

  background: linear-gradient(
      83.61deg,
      #2e4963 0.49%,
      #37b0c0 32.7%,
      #46a894 69%,
      #46536b 96.91%
    ),
    #050505;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
`;

export const Separator = styled.div`
  width: 100%;
  height: 1px;
  background: #0caacd;
  margin: 34px 0;
`;

export const AkashaFirstHub = styled(Box)<{
  selected: boolean;
}>`
  display: flex;
  width: 750px;
  background: url(${fistHubBackground});
  background-size: contain;
  background-repeat: no-repeat;
  border-radius: 30px;
  padding: 30px 20px;
  text-align: center;
  margin-bottom: 0;

  @media (max-width: 1000px) {
    width: 100%;
    flex-direction: column;
    background: url(${fistHubBackgroundMobile});
    background-size: contain;
    background-repeat: no-repeat;
  }
`;

export const Ic1 = () => (
  <svg
    width='30'
    height='30'
    viewBox='0 0 30 30'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M22.6171 7.02879H26.9241C28.2303 7.02879 30 8.80206 30 10.1047V16.1686H27.6564V26.9209C27.6564 28.3585 25.7951 30.0426 24.3481 29.9992L5.48644 29.9898C4.1028 29.9499 2.34479 28.3034 2.34479 26.9209V16.1686H0V10.1047C0 8.80206 1.76975 7.02879 3.07593 7.02879H7.38294C6.64476 5.54422 6.572 3.89535 7.37237 2.41899C8.89919 -0.391722 12.8893 -0.854111 14.9712 1.57988L15.0604 1.55289C16.971 -0.644041 20.453 -0.469178 22.231 1.81929C23.4127 3.34142 23.4702 5.33532 22.6171 7.02879ZM13.8282 7.02879V4.36243C13.8282 3.90004 13.2825 3.09497 12.9105 2.82035C10.791 1.25715 8.11055 3.75452 9.52705 5.96905C9.80871 6.41032 10.6326 7.02879 11.163 7.02879H13.8294H13.8282ZM16.1718 7.02879H18.8382C19.3006 7.02879 20.1056 6.48308 20.3802 6.11106C21.9833 3.9376 19.3287 1.22898 17.1248 2.79688C16.7328 3.07619 16.1718 3.88009 16.1718 4.3636V7.02997V7.02879ZM13.8282 9.37242H3.31064C2.94449 9.37242 2.34362 9.97329 2.34362 10.3394V13.8261H13.8282V9.37359V9.37242ZM27.6552 13.825V10.3383C27.6552 9.97212 27.0543 9.37125 26.6882 9.37125H16.1706V13.8238H27.6552V13.825ZM13.8282 16.1698H4.68724V26.6873C4.68724 27.0535 5.28811 27.6544 5.65427 27.6544H13.8282V16.1698ZM25.3116 16.1698H16.1706V27.6544H24.3446C24.7107 27.6544 25.3116 27.0535 25.3116 26.6873V16.1698Z'
      fill='#9FCCFF'
    />
  </svg>
);

export const Ic2 = () => (
  <svg
    width='32'
    height='38'
    viewBox='0 0 32 38'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M15.7422 0C21.0477 1.35541 26.2535 3.12468 31.4498 4.81213C31.7439 5.05048 31.8957 5.24733 31.9301 5.6351C32.0143 6.57902 31.8613 7.68422 31.8661 8.66017C31.8661 8.82974 31.9289 8.97442 31.9301 9.12857C31.9823 15.5511 32.574 21.8479 29.1102 27.5743C26.3175 32.1907 22.2952 34.5778 17.502 36.7503C17.1593 36.9056 16.4253 37.2875 16.0897 37.2969C15.6308 37.3088 14.6026 36.7847 14.1437 36.5736C8.58571 34.0157 4.10799 30.9705 1.66161 25.1326C-0.938931 18.9307 0.348888 11.9888 0.128322 5.45604C0.159154 5.22124 0.723612 4.71489 0.944178 4.61409L15.7422 0ZM29.5525 6.56124L16.0826 2.41318L2.44663 6.56124L2.43833 18.7279C2.90318 23.7274 5.48475 28.453 9.55217 31.3927C11.5337 32.824 13.8224 33.7596 16.0292 34.7818C18.1163 33.7952 20.2816 32.9319 22.1766 31.5954C26.3377 28.6593 29.0568 23.9966 29.562 18.9058L29.5537 6.56124H29.5525Z'
      fill='#9FCCFF'
    />
    <path
      d='M21.5743 13.6532C23.7645 14.2177 23.5772 16.3308 23.6365 18.1357C23.6851 19.6346 23.876 22.7106 23.0708 23.9617C22.4992 24.8499 21.6751 25.0159 20.7098 25.0301C17.8875 25.0716 14.8458 25.2661 12.0603 25.1535C9.64951 25.0562 8.55261 24.4811 8.42217 21.9233C8.34153 20.3461 8.58344 18.7583 8.60123 17.1882C8.61427 16.0759 8.29291 15.4628 9.07319 14.5224C9.44673 14.0718 9.98154 13.7967 10.5247 13.6058C10.5709 13.0437 10.5353 12.484 10.6195 11.9231C11.0524 9.03439 13.9363 7.04811 16.7918 7.45011C19.8762 7.88413 21.6964 10.6554 21.5731 13.6532H21.5743ZM19.1967 13.6022V12.3286C19.1967 11.7867 18.401 10.8001 17.9812 10.4645C16.7384 9.4684 15.4174 9.51821 14.145 10.4147C13.7964 10.6602 12.92 11.4808 12.92 11.9136V13.601H19.1967V13.6022ZM10.9219 15.9858C10.8591 16.0391 10.7938 16.9427 10.7855 17.123C10.7144 18.7583 10.9599 20.4469 10.9089 22.1035C10.9041 22.2707 10.7701 22.5197 10.9065 22.6348C10.999 22.713 11.7022 22.7747 11.8813 22.7854C14.6253 22.936 17.425 22.5826 20.1762 22.662C20.8735 22.6822 21.1664 23.0296 21.2624 22.0952C21.3964 20.7789 21.3846 19.0535 21.3312 17.7171C21.3158 17.3364 21.2944 16.5206 21.196 16.1945C21.1652 16.0925 21.1201 16.0047 21.0324 15.9407C19.1469 16.0273 17.2602 15.9466 15.3795 15.9134C15.268 15.9111 15.1518 15.8553 15.0261 15.853C13.6719 15.8257 12.2607 15.8079 10.9231 15.9881L10.9219 15.9858Z'
      fill='#9FCCFF'
    />
    <path
      d='M15.6295 16.8138C17.1272 16.6111 18.2289 18.1657 17.5506 19.5057C17.4616 19.68 17.1071 19.9978 17.0774 20.0974C16.9719 20.452 17.1367 20.8362 16.9387 21.3212C16.5331 22.3149 14.918 22.1726 14.7603 20.969C14.7259 20.7093 14.8089 20.3192 14.7437 20.0974C14.7105 19.9848 14.4626 19.8199 14.3749 19.6966C13.6041 18.6104 14.3097 16.9929 15.6295 16.8138Z'
      fill='#9FCCFF'
    />
  </svg>
);

export const Ic3 = () => (
  <svg
    width='32'
    height='39'
    viewBox='0 0 32 39'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M2.95808 14.0035L8.61727 15.4421C8.99247 11.2802 11.2667 7.34996 14.6122 4.60078C17.0131 2.6288 20.1562 1.48432 22.9076 0C22.5242 3.39534 21.6734 6.66876 22.9076 10.0047C24.5433 14.4271 28.8153 15.7423 30.7818 19.9042C34.8859 28.5891 28.1159 38.4079 18.0218 38.9489C11.9693 39.2735 6.68041 38.1229 2.91858 33.4657C-1.83883 27.5757 -0.0105734 20.2044 2.95972 14.0035H2.95808ZM23.7288 34.918C28.6244 32.1201 30.7489 26.3687 28.7396 21.3382C27.3524 17.8652 24.0924 16.5546 22.0519 13.6118C20.9526 12.0269 20.1282 9.96962 19.8797 8.09365C19.7036 6.77087 19.8205 5.43742 19.8287 4.11007C15.6209 6.05462 12.435 9.56425 11.3687 13.8465C10.9771 15.4162 11.0067 16.8944 10.9178 18.4869L4.38974 16.8106C2.82149 20.5564 1.6811 25.0201 3.11605 28.9488C3.85822 30.9817 5.36722 32.9049 7.18396 34.2323C7.29915 34.3161 8.13676 34.9059 8.20752 34.8419C6.49117 31.7315 7.69739 28.17 9.1126 25.1801L11.8212 25.8658C12.0253 24.3526 12.8794 22.7829 13.9539 21.6415C15.6341 19.8554 18.0235 19.0249 20.1973 17.8773C19.9538 20.3903 19.0372 22.7677 20.7387 25.0216C21.2867 25.7485 22.1622 26.2514 22.7858 26.9296C24.8395 29.1621 25.0864 32.303 23.7304 34.918H23.7288ZM10.5097 27.9978C9.93539 29.8525 9.42526 31.8305 10.3287 33.6745C12.6128 38.3454 21.5039 37.4935 22.0766 32.207C22.4979 28.3148 19.6049 28.1563 18.0992 25.4117C17.5315 24.3754 17.2599 23.1426 17.2402 21.9844C15.9204 22.7966 14.8722 24.0706 14.4065 25.4833C14.0346 26.611 14.1333 27.7433 14.0379 28.9076L10.5097 27.9978Z'
      fill='#9FCCFF'
    />
  </svg>
);

export const Ic4 = () => (
  <svg
    width='30'
    height='24'
    viewBox='0 0 30 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M14.7879 0.012544C15.3422 -0.0572716 15.8571 0.170972 16.2752 0.532134L21.9099 7.15657L27.6101 3.56509C29.0162 3.12874 30.2008 4.2525 29.9714 5.71595L27.4096 21.987C27.2078 22.9027 26.4687 23.6344 25.5999 23.8855C18.7597 24.1151 11.8788 23.9163 5.02277 23.9862C3.03228 23.77 2.70468 22.5925 2.39673 20.8471C1.50697 15.8244 0.919914 10.7386 0.0288432 5.71595C-0.201787 4.2525 0.984123 3.12874 2.39018 3.56509L8.09041 7.15657L13.6924 0.565699C14.0016 0.291807 14.3725 0.0649058 14.7879 0.012544ZM20.5824 8.88316L15.0263 2.34331L14.8691 2.44132C12.9494 4.68885 11.0938 7.03036 9.06928 9.16511C8.47829 9.50076 7.88992 9.50747 7.27796 9.2121L2.1779 5.9603L3.87355 16.4501H26.1228L27.8184 5.9603L22.5389 9.29534C21.8155 9.56789 21.1433 9.41215 20.5811 8.8845L20.5824 8.88316ZM25.7926 18.6224H4.20639L4.61524 21.454C4.66372 21.6594 4.8249 21.8044 5.02801 21.8353L24.8465 21.842C25.0823 21.8528 25.2828 21.7333 25.3693 21.5064L25.7913 18.6224H25.7926Z'
      fill='#9FCCFF'
    />
  </svg>
);

export const Ic5 = () => (
  <svg
    width='33'
    height='33'
    viewBox='0 0 33 33'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M8.02261 20.0775H12.0805C12.4085 20.0775 12.7873 20.6391 12.8594 20.9314C12.9825 21.4266 12.9777 23.5537 12.7998 24.0152C12.5123 24.7643 11.3007 24.7749 10.8555 24.1835C10.8285 24.1479 10.7112 23.9575 10.7112 23.9431V22.2863H2.16359V30.7878H10.7122V29.4665C10.7122 29.4521 10.8295 29.2617 10.8564 29.2261C11.3017 28.6347 12.5133 28.6453 12.8008 29.3944C12.9681 29.83 12.9844 31.7359 12.8623 32.1917C12.5844 33.2244 11.4584 32.9225 10.6382 32.9456C7.42834 33.0379 4.20314 32.9812 0.986599 32.9946C0.540418 32.9436 0.148086 32.6706 0.0230783 32.2292L0 21.0093C0.0432719 20.4496 0.507723 20.1275 1.03468 20.0756C1.89531 19.9909 2.81556 20.1121 3.6733 20.1256C3.93678 20.1294 5.21955 20.1611 5.3484 20.0794C5.60515 19.5159 6.00902 19.0476 6.41193 18.586C7.29949 17.5706 8.35724 16.483 9.34096 15.5599C9.78041 15.1474 10.6276 14.28 11.2151 14.2165C12.0613 14.1242 12.6267 14.7935 12.3681 15.6089C12.1094 16.4244 9.92753 18.1841 9.22172 18.8505C8.80727 19.2419 8.41109 19.6611 8.02165 20.0756L8.02261 20.0775Z'
      fill='#9FCCFF'
    />
    <path
      d='M24.8803 12.92H20.9176C20.606 12.92 20.1502 12.3565 20.0877 12.069C19.9656 11.5103 19.9761 9.69098 20.1098 9.13421C20.2887 8.38898 21.2224 8.17646 21.8224 8.55629C21.9301 8.62457 22.2388 8.9342 22.2388 9.05248V10.7093H30.7874V2.20975H22.2388V3.86658C22.2388 3.88101 22.1215 4.0714 22.0945 4.10698C21.6003 4.76279 20.3175 4.63682 20.1108 3.78581C19.9781 3.23962 19.9656 1.39816 20.0896 0.851975C20.1839 0.43368 20.48 0.137508 20.8916 0.0211551L32.0134 0C32.399 0.0557726 32.7577 0.283671 32.8904 0.659656L32.9039 12.1306C32.8558 12.644 32.3269 12.8777 31.8682 12.92C30.5056 13.0441 29.0421 12.7517 27.667 12.8979C27.2987 13.4133 26.9622 13.9384 26.5381 14.4105C25.6496 15.4009 24.6101 16.2702 23.6543 17.1943C23.2802 17.5559 22.5398 18.479 22.1426 18.6608C21.3339 19.031 20.48 18.5146 20.5589 17.6049C20.5954 17.1789 20.8666 16.8953 21.133 16.5943C22.2917 15.2884 23.7735 14.2682 24.8803 12.921V12.92Z'
      fill='#9FCCFF'
    />
    <path
      d='M26.7534 26.8009V14.8655C26.7534 14.503 27.2871 14.152 27.615 14.0943C28.3429 13.9664 28.8584 14.3357 28.9574 15.0626L28.917 28.2202C28.8949 28.3837 28.3881 28.8943 28.2208 28.9164C27.7948 28.9731 27.1832 28.8991 26.7275 28.9116C22.8176 29.0173 18.8856 28.9404 14.9681 28.9558C14.1401 28.8327 13.8209 27.9519 14.2171 27.2547C14.2863 27.1326 14.595 26.7999 14.7229 26.7999H26.7544L26.7534 26.8009Z'
      fill='#9FCCFF'
    />
    <path
      d='M6.19746 6.19565V18.1791C6.19746 18.3301 5.91187 18.6378 5.78109 18.7233C5.04739 19.2032 4.09926 18.8166 3.99348 17.9339C3.83578 16.6155 4.03098 14.8318 4.03868 13.4749C4.05406 10.5757 4.02425 7.67651 4.03387 4.77634C4.05118 4.6494 4.49159 4.18207 4.60986 4.10322C4.68295 4.05418 4.72429 4.01475 4.82622 4.0311L18.0328 4.03783C18.8165 4.19265 19.1204 4.985 18.7723 5.68216C18.704 5.81871 18.3703 6.19565 18.229 6.19565H6.19746Z'
      fill='#9FCCFF'
    />
    <path
      d='M7.70323 24.9593C8.55232 25.9421 10.0072 26.2911 11.24 25.9594C12.3564 25.6594 12.7478 24.9093 13.5209 24.1573C15.3931 22.3361 19.5405 19.5321 17.5519 16.5261C16.9192 15.5693 16.1143 15.5443 15.5701 14.9058C14.8489 14.0577 15.5777 12.8268 16.6778 13.1259C18.5145 13.6259 20.0963 15.8905 20.2242 17.7444C20.4127 20.4975 19.051 21.9235 17.2942 23.7515C16.1076 24.9853 13.9315 27.2739 12.3929 27.8797C9.64758 28.9624 6.61758 27.8028 5.27712 25.1987C4.90979 24.4843 4.46457 23.289 5.41366 22.8217C6.88491 22.0986 7.083 24.241 7.70226 24.9584L7.70323 24.9593Z'
      fill='#9FCCFF'
    />
    <path
      d='M27.7448 9.82842C27.0217 10.591 26.3255 10.0284 25.9284 9.30243C25.3928 8.32352 25.2187 7.66867 24.0629 7.18114C22.1532 6.37436 20.9338 7.26192 19.5963 8.47642C18.5039 9.46782 16.0009 11.8141 15.346 13.0152C14.5517 14.472 14.8383 16.1798 16.1143 17.2443C16.7692 17.7904 17.9567 18.1559 17.3981 19.2944C16.6442 20.8291 14.3825 18.7674 13.794 17.9799C11.9573 15.5172 12.592 12.694 14.4815 10.5188C15.7624 9.04472 17.651 7.08787 19.1905 5.90991C21.9839 3.77132 25.862 4.54541 27.5785 7.60521C27.9622 8.2889 28.3862 9.15338 27.7448 9.82938V9.82842Z'
      fill='#9FCCFF'
    />
  </svg>
);
